import React from 'react';
import { Link } from 'react-router-dom';

import Logo from '../../UI/Logo/Logo';
import NavigationLinks from '../NavigationLinks/NavigationLinks';

import classes from './Topbar.module.css';

const topBar = (props) => {
    let styleClasses = [classes.Topbar];

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }
    }

    props.topbarTheme === 'Dark' ? styleClasses.push(classes.Dark) : styleClasses.push(classes.Light);

    return (
        <header>
            <div className={styleClasses.join(' ')} id="Navbar">
                {
                    props.showQuizNavbar
                        ? <span className={classes.Logo} id="EdYodaLogoWithoutLink" >
                            <Logo topbarTheme={props.topbarTheme} />
                        </span>
                        : <Link to='/' className={classes.Logo} id="EdYodaLogo">
                            <Logo topbarTheme={props.topbarTheme} />
                        </Link>
                }

                <NavigationLinks
                    styleclass={props.styleclass}
                    topbarTheme={props.topbarTheme}
                    loginButtonClick={props.loginButtonClick}
                    userLoggedIn={props.userLoggedIn}
                    profileDropDownOpen={props.profileDropDownOpen}
                    onProfileAvatarClick={props.onProfileAvatarClick}
                    notificationsDropDownOpen={props.notificationsDropDownOpen}
                    onNotificationIconClick={props.onNotificationIconClick}
                    countChanged={props.countChanged}
                    onViewAllNotificationsClick={props.onViewAllNotificationsClick}
                    notifications={props.notifications}
                    unreadNotifCount={props.unreadNotifCount}
                    logoutClicked={props.logoutClicked}
                    showLoader={props.showNotificationLoader}
                    username={props.username}
                    userProfilePic={props.userProfilePic}
                    activeProgramBatchCode={props.activeProgramBatchCode}
                    fullName={props.fullName}
                    showQuizNavbar={props.showQuizNavbar}
                    programType={props.programType}
                    community={props.community}
                    showMDStudentPopup={props.showMDStudentPopup}
                />
            </div>
        </header >
    );
}

export default topBar;